import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

// Initial state
const initialState = {
    documents: [],
    totalRecord: null,
    loading: false,
    error: null
};

const ehrDocumentSlice = createSlice({
    name: 'ehrDocuments',
    initialState,
    reducers: {
        setDocuments(state, action) {
            state.documents = action.payload;
        },
        clearDocuments(state) {
            state.documents = [];
            state.totalRecord = null;
            state.error = null;
        },
        setTotalRecord(state, action) {
            state.totalRecord = action.payload;
        },
        loadingStarted(state) {
            state.loading = true;
            state.error = null;
        },
        loadingSuccess(state) {
            state.loading = false;
            state.error = null;
        },
        loadingFailed(state, action) {
            state.loading = false;
            state.error = action.payload;
        }
    }
});

export const {
    setDocuments,
    clearDocuments,
    setTotalRecord,
    loadingStarted,
    loadingSuccess,
    loadingFailed
} = ehrDocumentSlice.actions;


export const fetchEhrDocuments = (payload) => async (dispatch) => {
    dispatch(loadingStarted());

    try {
        const res = await axios.post(
            'https://healthdata.api.calciumhealth.com/ehrpdf',
            // 'https://hc-platform-node-func-prod-03.azurewebsites.net/api/GetPdfAndImage?code=zYcXZaeNh0gb9UOaioV3oiLYf4D7BlNpj7Ca8E4agwrrwKttnqXPow==',
            payload
        );

        const docs = res.data?.documents || [];

        if (docs.length > 0) {
            const parsedDocs = docs.map((doc, index) => ({
                id: index,
                base64Data: doc.base64Data,
                contentType: doc.contentType
            }));
            dispatch(setDocuments(parsedDocs));
            dispatch(loadingSuccess());
        } else {
            dispatch(clearDocuments());
            dispatch(loadingFailed('No EHR Documents available.'));
        }
    } catch (error) {
        console.error('Error fetching EHR Documents:', error);
        dispatch(clearDocuments());
        dispatch(loadingFailed('Error fetching EHR Documents'));
    }
};

export default ehrDocumentSlice.reducer;
